import {selectObjectCreator} from "../../AssetSchemas/AssetSchemas/AddSchema/dataDef";

export const initialValueCreator = (data, type) => {
  const keys = Object.keys(data);
  const values = Object.values(data);
  let result = {};
  keys.map((key, i) => {
    if (type === 'add') {
      if (values[i].type === 'boolean') {
        result[key] = values[i].default && selectObjectCreator('Yes', true)
          || selectObjectCreator('No', false);
      } else {
        if (values[i].hasOwnProperty('default')) {

          result[key] = values[i].default
        } else {
          result[key] = '';
        }
      }
    } else {
      if (values[i].type === 'boolean') {
        result[key] = values[i].value && selectObjectCreator('Yes', true)
          || selectObjectCreator('No', false);
      } else {
        result[key] = values[i].value
      }
    }
  });
  return result;
};

export const isEquivalent = (a, b) => {
  let aProps = Object.getOwnPropertyNames(a);
  let bProps = Object.getOwnPropertyNames(b);
  if (aProps.length !== bProps.length) {
    return false;
  }
  for (let i = 0; i < aProps.length; i++) {
    let propName = aProps[i];
    if (a[propName] !== b[propName]) {
      return false;
    }
  }
  return true;
};

export const preCreatingEditValues = (data, schema) => {
  const {fin_structure, waterfall_items} = schema;
  let result = {
    name: fin_structure.name,
    waterfall_items: [],
  };

  const dataValues = Object.values(data);
  let count = 0;

  waterfall_items.map((item) => {

    const itemKeys = Object.keys(item.data);
    const itemValues = Object.values(item.data);
    const waterfall_item = {
      data: {},
      waterfall_item_id: item.waterfall_item_id
    };

    itemKeys.map((key, i) => {
      if (itemValues[i].type === 'integer' || itemValues[i].type === 'number') {
        waterfall_item.data[key] = +dataValues[count + i];
      } else {
        waterfall_item.data[key] = dataValues[count + i];
      }
    });
    result.waterfall_items.push(waterfall_item);
    count += itemKeys.length;

  });
  return result;
};

export const preCreatingAddValues = (data,schema,name,setFinSchemaError) => {
  let result = {
    name,
    waterfall_items: [],
  };

  const dataValues = Object.values(data);
  const dataKeys = Object.keys(data);
  let errorsExist = false;
  let count = 0;
  schema.map((item) => {

    const itemKeys = Object.keys(item.waterfall_item_data.properties);
    const itemValues = Object.values(item.waterfall_item_data.properties);
    const waterfall_item = {
      data: {},
      waterfall_item_id: item.waterfall_item_id
    };

    itemKeys.map((key, i) => {

      if (itemValues[i].type === 'integer' || itemValues[i].type === 'number') {
        waterfall_item.data[key] = +dataValues[count + i];
      } else {
        waterfall_item.data[key] = dataValues[count + i];
      }
      if(dataValues[count + i] === '' && item.waterfall_item_data.required.includes(key)){
        setFinSchemaError('Field is required',dataKeys[count + i]);
        errorsExist = true;
      }
    });
    result.waterfall_items.push(waterfall_item);
    count += itemKeys.length;

  });
  return {result,errorsExist};
};



// WEBPACK FOOTER //
// ./src/views/FinancicalStructure/FinancicalStructure/helpers.js